(function () {
    'use strict';
    var m = angular.module('profiles');
    m.controller('IpProfileController', ["$scope", "$routeParams", "widgetPolling", "sizeClasses", "path", "feature", function ($scope, $routeParams, widgetPolling, sizeClasses, path, feature) {
        var module = $routeParams.module;
        widgetPolling.scope({ id: $routeParams.id });
        widgetPolling.updateWidgets(path('profiles').ctrl('ip-profile').json(module + '.ip-profile').path);
        $scope.widgetPolling = widgetPolling;
        $scope.getSizeClasses = sizeClasses;
        if (feature.guiV2) {
            $scope.wrapperClass = 'profile-v2 content-paddings';
        }
    }]);
}());